import { SupabaseClient } from "@supabase/supabase-js";

import { Database } from "../../supabase.types";
import createNoAuthSupabaseClient from "../../supabase/supabase";

/**
 * Given a list of Tixologi Event IDs, return a map from each Tixologi ID
 * to the corresponding punchup comedian_shows UUID. IDs that don't have a
 * matching row are omitted from the result. The ONE owner of this crossing:
 * a caller holding its own client passes it in rather than re-deriving the
 * query, and one that does not gets the unauthenticated read.
 */
export async function getPunchupShowIdsByTixologiIds(
  tixologiEventIds: string[],
  injectedSupabase?: SupabaseClient<Database>
): Promise<Record<string, string>> {
  if (tixologiEventIds.length === 0) return {};

  const supabase = injectedSupabase ?? createNoAuthSupabaseClient();
  const { data, error } = await supabase
    .from("comedian_shows")
    .select("id, tixologi_event_id")
    .in("tixologi_event_id", tixologiEventIds);

  if (error) throw error;

  const map: Record<string, string> = {};
  for (const row of data ?? []) {
    if (row.tixologi_event_id) {
      map[row.tixologi_event_id] = row.id;
    }
  }
  return map;
}
